import { call, put, takeLatest } from 'redux-saga/effects';

import { getSystemMessages as getSystemMessagesApi } from '../../services';
import { checkOnline } from '../notifications';
import { REQUEST_SYSTEM_MESSAGES, receiveSystemMessages } from './actions';

export function* doRequestSystemMessages() {
  try {
    const { values: systemMessages } = yield call(getSystemMessagesApi);
    yield put(receiveSystemMessages(systemMessages));
  } catch (error) {
    yield console.error(error);
    yield call(checkOnline);
  }
}

export const sagas = [takeLatest(REQUEST_SYSTEM_MESSAGES, doRequestSystemMessages)];
